module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/tradingbgs-f9e11642b1aa3b0dac9839cb03f31bb5.png";